// work data

export const Work = [
    {
        id: 1,
        name: "CryptoInsight",
        description: "I built a cryptocurrency price tracking app using CoinGecko API. The app features a search bar, price charts, current prices, market caps, and 24-hour price changes.",
        tags: ["React js", "CoinGecko API", "HTML", "CSS", "Javascript"],

        demo: "https://cryptoinsightprice.netlify.app/",
        github: "https://github.com/shreenathmessi/CryptoInsight"
    },
    {
        id: 2,
        name: "Delight Nation",
        description: "In this React JS project, I created the Home page to display menu items, the Cart and Order pages, and a Sign In / Sign Up popup for user authentication.",
        tags: ["React js", "HTML", "CSS", "Javascript"],

        demo: "https://delightnation.netlify.app/",
        github: "https://github.com/shreenathmessi/Delight-Nation"

    },
    {
        id: 3,
        name: "WeatherWhiz",
        description: "Built with React JS and the OpenWeatherMap API, this app shows real-time weather data (temperature, weather condition, humidity, wind speed) for any location.",
        tags: ["React js", "OpenWeatherMap API", "HTML", "CSS", "Javascript"],

        demo: "https://weatherwhizapp.web.app/",
        github: "https://github.com/shreenathmessi/WeatherWhiz"
    },




] 